import Component from "../abstracts/Component";

import 'gsap';
import ScrollMagic from 'scrollmagic';
// import 'debug.addIndicators';
import 'animation.gsap'
import { TimelineLite, TweenLite } from "gsap";


export default class FullScreenCoverComponent extends Component {
  get SELECTORS() {
    return {
      main: '.c-fullscreen-cover',
      parallaxPicture: '.c-fullscreen-cover picture.zoom img',
      darkLayer: '.c-fullscreen-cover .dark-layer',
    }
  }

  bindEvents() {

    // attivo il parallasse solo se sono ad una risoluzione maggiore di 768
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 768) {

      var offset = document.querySelector(this.SELECTORS.main).offsetHeight;
      var controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 0,
          duration: offset
        }
      });

      var timeline = new TimelineLite();

      var tween1 = TweenLite.to(this.SELECTORS.parallaxPicture, 1, {scale: 1.7});
      var tween2 = TweenLite.to(this.SELECTORS.darkLayer, 1, {backgroundColor: "rgba(0, 0, 0, 0.7)"});

      timeline
        .add(tween1)
        .add(tween2, "-=1");

      new ScrollMagic.Scene({
          triggerElement: this.SELECTORS.main
        })
        .setTween(timeline)
        // .setTween(this.SELECTORS.parallaxPicture, 1, {scale: 1.7})
        // .addIndicators()
        .addTo(controller);
    }

  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }

}
